import { handleError } from '@anchorage/sentry';

export function convertEpochToDate(timestamp: number | string): Date {
  const timestampAsNumber = Number(timestamp);
  if (Number.isNaN(timestampAsNumber)) {
    handleError(
      new Error(
        `Unsupported timestamp format in convertEpochToDate: ${timestamp.toString()}`,
      ),
    );
  }

  const date = new Date(0);
  date.setUTCSeconds(timestampAsNumber);
  return date;
}
